/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Nav_CompareInputs */

const en_wc_nav_compare = /** @type {(inputs: Wc_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Word`)
};

/**
* | output |
* | --- |
* | "vs Word" |
*
* @param {Wc_Nav_CompareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_nav_compare = /** @type {((inputs?: Wc_Nav_CompareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Nav_CompareInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_nav_compare(inputs)
});
export { wc_nav_compare as "wc.nav.compare" }